
import styled from "styled-components";


import { Nav } from "rsuite";

export default styled(Nav)`
    &&&&&& {
        .rs-nav-waterline {
            border-bottom: 1.5px solid var(--color-main);
            border-top: unset;
        }
        
        .rs-nav-item.rs-nav-item-active {
            border-color: var(--color-main);
            color: var(--color-main);
        }

        .rs-nav-item:not(.rs-nav-item-active) {
            color: var(--color-grey);
        }

        &.rs-nav-tabs.rs-nav-horizontal .rs-nav-item.rs-nav-item-active {
            border-bottom-color: var(--rs-bg-card);
        }

        &.rs-nav-tabs.rs-nav-horizontal .rs-nav-bar {
            border-top-color: var(--color-main);
        }
    }
`;
